import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
  loading: '/img/spinner.svg',
  lazyComponent: true,
  attempt: 1,
});

export default VueLazyload;
